(function() {
    'use strict';

    angular
        .module('as.groups')
        .controller('groupsController', groupsController);

    groupsController.$inject = ['$scope', 'groupsList', '$state', '$rootScope','$stateParams','features','$filter'];

    function groupsController($scope, groupsList, $state, $rootScope, $stateParams, features,$filter) {
        //variables
        $scope.info={groupCatToShow:false};


        //function bindings
        activate();
        $scope.processDataFetched = processDataFetched;

        function activate() {
            if($stateParams && $stateParams.featureName=="groups" && $stateParams.cbt){
                $scope.info.groupCatToShow=$stateParams.cbt;
            }
            console.log('groupsList', groupsList);
            $scope.group = groupsList.data
            console.log('$scope.group', $scope.group);
            if($scope.group && $scope.group.data && $scope.group.data.tag && $scope.group.data.tag=='#chapters')
                processChaptersData();
            else if($scope.group && $scope.group.data && $scope.group.data.tag && $scope.group.data.tag=='#groups')
                processGroupsData();
            else{
                initPageBuilderView();
                evalObj($scope.pageBuilderData);
            }
        }

        function processChaptersData() {
            $scope.chapterCat = $scope.group.data.childs;
        }

        function processGroupsData() {
            var groupsMeta = features.getFeature("groups");
            var categories = null;
            if(groupsMeta.categories) categories = groupsMeta.categories;

            $scope.groupCat = processDataFetched({repeat_data: $scope.group.data.childs},categories);
            if(angular.isDefined($scope.groupCat) && $scope.groupCat.categories)
                $scope.groupCat = $scope.groupCat.categories;
            else if(angular.isDefined($scope.groupCat.repeat_data)){
                $scope.groupCat = [{
                    category: $scope.group.data.name,
                    category_order: 0,
                    repeat_data: $scope.groupCat.repeat_data
                }];
            }
            else{
                $scope.groupCat = [];
            }
        }

        function processDataFetched(resp,categories) {
            if(resp && resp.repeat_data){
                var other_name = $scope.group.data.name;
                var formatted_obj = {};
                formatted_obj['categories'] = {};
                angular.forEach(resp.repeat_data,function(value,key) {
                    if(value && value.attributes && value.attributes.category && value.attributes.category!=-1){
                        if(!formatted_obj['categories'][value.attributes.category]){
                            formatted_obj['categories'][value.attributes.category] = {};
                            formatted_obj['categories'][value.attributes.category].repeat_data = [];
                            formatted_obj['categories'][value.attributes.category].category_order = 0;
                        }
                        formatted_obj['categories'][value.attributes.category].repeat_data.push(value);
                        if(value.attributes.category_order && !formatted_obj['categories'][value.attributes.category].category_order)
                            formatted_obj['categories'][value.attributes.category].category_order = value.attributes.category_order;
                    }
                    else{
                        if(!formatted_obj['categories'][other_name]){
                            formatted_obj['categories'][other_name] = {};
                            formatted_obj['categories'][other_name].repeat_data = [];
                            formatted_obj['categories'][other_name].category_order = 0;
                        }
                        formatted_obj['categories'][other_name].repeat_data.push(value);
                    }
                });
                var formatted_obj_arr = {};
                formatted_obj_arr['categories'] = [];
                if (categories) {
                    for (var i = 0; i < categories.length; i++) {
                        categories[i].__hide = false;
                        var catFound = false;
                        for (var key in formatted_obj['categories']) {
                            var val = formatted_obj['categories'][key];
                            if(categories[i].category === key){
                                categories[i].repeat_data = val.repeat_data;                                
                                catFound = true;
                                break;
                            }
                        }
                        if(!catFound)
                            categories[i].repeat_data = [];
                        if(!$scope.info.groupCatToShow && categories[i].hide_in_allCat)
                            categories[i].__hide = true;
                        formatted_obj_arr['categories'].push(categories[i]);
                    }
                    if(formatted_obj['categories'][other_name]) {
                        var val = formatted_obj['categories'][other_name];
                        formatted_obj_arr['categories'].push({category: other_name, category_order: val.category_order, repeat_data: val.repeat_data});
                    }
                }
                else{
                    angular.forEach(formatted_obj['categories'], function (val, key) {
                        formatted_obj_arr['categories'].push({category: key, category_order: val.category_order, repeat_data: val.repeat_data});
                    });                    
                }

                // console.log('formatted_obj_arr',formatted_obj_arr);
                if(formatted_obj_arr['categories'].length && formatted_obj_arr['categories'].length>1)
                    return formatted_obj_arr;
                else
                    return resp;
            }
            return resp;
        }

        function evalObj(obj) {
            for (var key in obj) {
                var value = obj[key];

                if (typeof value === 'object') {
                    evalObj(value);
                }

                if (key.indexOf("eval-") != -1) {
                    obj[key.replace("eval-", "")] = eval(value);
                    delete obj[key];
                }

            }
        }

        function initPageBuilderView() {
            var chapterView = {
                "commonconf": {
                    "headingClasses": "font-20 mdl-typography--font-light mdl-color-text--white",
                    "eval-cid": "$rootScope.app_data.cid",
                    "eval-userSource": "$scope.userSource",
                    "mainDivClasses": "no-padding--as-header-themed border-box align-self-center",
                    "headingParent": "border-radius-2 inline-block font-20 mdl-typography--font-light mdl-color-text--white mdl-color--primary-dark padding-10 margin-top-16 margin-bottom-8",
                    "viewMoreButtonClasses": "button-background mdl-button mdl-js-button mdl-typography--font-regular font-12 padding-lr-8 border-box"
                },
                "elementsConf": [
                // {
                //     "template_name": "simpleHtml",
                //     "ctrlName": "simpleHtmlCtrl",
                //     "template_type": 3,
                //     "tConfiguration": {
                //         "textClasses": "font-18 mdl-typography--headline mdl-typography--font-light mdl-color-text--white",
                //         "parentDivClasses": "about-strip-change mdl-color--primary-dark autoscroll-class",
                //         "innerDivClasses": "mdl-grid about-size",
                //         "headingClasses": "about-title about-size mdl-typography--font-light mdl-color-text--white margin-tb-24",
                //         "headingStyles": "line-height:1.3"
                //     },
                //     "tData": {
                //         "heading": {
                //             "type": "direct",
                //             "eval-value": "$scope.group.data.name"
                //         },
                //         "backgroundimage":{
                //             "type": "direct",
                //             "value": "https://afilemanager.s3.dualstack.ap-southeast-1.amazonaws.com/prod/cid_0/T9hcEBT.jpg"
                //         }
                //     }
                // },
                {
                    "template_name": "userCardWrapper",
                    "ctrlName": "userCardWrapperCtrl",
                    "template_type": 1,
                    "tData": {
                        "child_repeat_data": {
                            "type": "direct",
                            "eval-value": "$scope.group.data.childs"
                        }
                    },
                    "tConfiguration": {
                        "localDirectChildKeys": {
                            "childs": "repeat_data",
                            "name": "heading",
                        },
                        "wrapperParentClasses":"change-size margin-auto padding-lr-8 border-box center-alignment",
                        "child_common": {
                            "tConfiguration": {
                                "cardClasses": "mdl-grid nested_grid margin-auto",
                                "textClasses": "margin-top-8 margin-bottom-4 font-16 mdl-typography--font-regular mdl-color-text--white",
                                "singleCardClasses": "mdl-cell mdl-cell--4-col mdl-cell--4-col-tablet small-tablet border-light-grey mdl-color--white flexbox flex-dir-column justify-content-center",
                                "singleCardStyles": "margin-left: auto;margin-right: auto;",
                                "imageStyles": "max-width:100%;max-height:100%;",
                                "imageClasses": "align-self-center ng-hide",
                                "customClass1": "cursor-pointer left-alignment mdl-typography--font-light padding-18",
                                "nameClasses": "inline-block font-24 margin-bottom-20 margin-top-10",
                                "textStyles": "",
                                "dateClasses": "font-12",
                                "dateStyles": "margin-bottom:10px;",
                                "buttonText": $filter('asPortalLang')('View','View'),
                                "singleCardInsideClasses": "flexbox flex-grow-3 flex-dir-column",
                                "buttonClasses": "mdl-button--raised min-width-button rel-pos font-14  align-self-end mdl-button mdl-js-button mdl-button--accent mdl-typography--font-light",
                                "buttonStyles": "",
                                "viewCountClasses": "font-12",
                                "buttonLinkState": "inapp.chapter_detail.main",
                                "altDivClasses": "mdl-color--black",
                                "altDivStyles": "opacity:0.4",
                                "imagebgClasses":"abs-pos object_fit_background",
                        		// "altdivOrderedClass": ["mdl-color--blue-800","mdl-color--red-900"],
                                "customDivStyles": "width:100%",
                                "convertorConfig": {
                                    "repeat_data": {
                                        "photo": ["attributes.photo_small"],
                                        // "signature":["college_info"],
                                        "text": ["attributes.description"],
                                        // "clickStateParams":["tag"]
                                        // "buttonLink":["link"]
                                    }
                                }
                            },
                            "template_type": "leftOverlay",
                            "template_name": "userCard",
                            "ctrlName": "asUserCard"
                        }

                    }
                }]
            };
            //temp json from sig
            var sigView = {
                "commonconf": {
                    "headingClasses": "font-20 mdl-typography--font-light mdl-color-text--white",
                    "eval-cid": "$rootScope.app_data.cid",
                    "eval-userSource": "$scope.userSource",
                    "mainDivClasses": "border-box margin-top-20 change-size align-self-center padding-lr-8",
                    "mainDivStyles": "margin:auto",
                    "headingParent": "border-radius-2  inline-block font-20 mdl-typography--font-light mdl-color-text--white mdl-color--primary-dark padding-10 margin-top-16 margin-bottom-8",
                    "viewMoreButtonClasses": "button-background mdl-button mdl-js-button mdl-typography--font-regular font-12 padding-lr-8 border-box"
                },
                "elementsConf": [{
                    "template_type": "leftOverlay",
                    "template_name": "userCard",
                    "ctrlName": "asUserCard",
                    "tData": {
                        "repeat_data": {
                            "type": "direct",
                            "eval-value": "$scope.group.data.childs"
                        },
                        "heading": {
                            "type": "direct",
                            "eval-value": "$scope.group.data.name"
                        }
                    },
                    "tConfiguration": {
                        "headingParentClasses": "maximize-width",
                        "cardClasses": "nested_grid mdl-grid",
                        "textClasses": "margin-top-8 margin-bottom-4 font-16 mdl-typography--font-regular mdl-color-text--white",
                        "singleCardClasses": "mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet small-tablet border-light-grey mdl-color--white flexbox-inline flex-dir-column justify-content-center cursor-pointer",
                        "imageStyles": "max-width:100%;max-height:100%;",
                        "imageClasses": "align-self-center",
                        "customClass1": "left-alignment mdl-typography--font-light padding-18",
                        "nameClasses": "mdl-typography--font-regular inline-block font-24 margin-bottom-20 margin-top-10",
                        "textStyles": "",
                        "dateClasses": "font-12",
                        "dateStyles": "margin-bottom:10px;",
                        "singleCardStyles":"height:130px;",
                        // "buttonText": "View",
                        "singleCardInsideClasses": "flexbox flex-grow-3 flex-dir-column",
                        "buttonClasses": "mdl-button--raised min-width-button rel-pos font-14  align-self-end mdl-button mdl-js-button mdl-button--accent mdl-typography--font-light",
                        "buttonStyles": "",
                        "viewCountClasses": "font-12",
                        // "buttonLinkState": "inapp.chapters",
                        "cardLinkState" :"inapp.group_detail.main",
                        "altDivClasses": "mdl-color--black",
                        "altdivOrderedClass": ["mdl-color--blue-800","mdl-color--brown-800","mdl-color--red-900"],
                        "altDivStyles": "opacity:0.4",
                        "customDivStyles": "width:100%",
                        "convertorConfig": {
                            "repeat_data": {
                                "photo": ["attributes.photo_small"],
                                // "signature":["college_info"],
                                "text": ["attributes.description"],
                                // "buttonLink":["link"]
                            }
                        }
                    }
                }]
            }



            if ($scope.group.data != undefined && $scope.group.data.tag_type == 1) {
                $scope.pageBuilderData = chapterView;
            } else if ($scope.group.data != undefined && $scope.group.data.tag_type == 4) {
                $scope.pageBuilderData = sigView;

            }
        }
    }
})();